import { ERROR_COPY, isApiError, type ErrorCode } from '@racksavant/core';

/** Never show a stack trace to someone who is looking at a photo of themselves. */
export function errorMessage(error: unknown): string {
  if (isApiError(error)) return error.message || ERROR_COPY[error.code as ErrorCode] || 'Something went wrong.';
  if (error instanceof Error && error.message) return error.message;
  return 'Something went wrong.';
}

export function errorCode(error: unknown): ErrorCode | null {
  return isApiError(error) ? (error.code as ErrorCode) : null;
}

/** Field-level messages the API sends back for forms. */
export function errorFields(error: unknown): Record<string, string> {
  return isApiError(error) && error.fields ? error.fields : {};
}
